import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PageRequest, SpringPage } from '@shared/page';
import { addPaginationAndHttpParams } from '@shared/utils/request-utils';
import { TrackingEvent } from '../models/tracking';
import { AbstractOrganizationService } from '@shared/services/abstractOrganizationService';
import { AuthService } from '@shared/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AdminClusterTrackingService extends AbstractOrganizationService {
  constructor(private readonly http: HttpClient, auth: AuthService) {
    super(auth);
  }

  public getTrackings(clusterUid: string, queryParams: any, pageRequest: PageRequest): Observable<SpringPage<TrackingEvent>> {
    return this.http.get<SpringPage<TrackingEvent>>(
      this.url(`clusters/${clusterUid}/tracking`),
      { params: addPaginationAndHttpParams(queryParams, pageRequest) });
  }
}
